import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { GET_VENDOR_CONFIGURATION, GET_VENDOR_CONFIGURATION_SUCCESS, GET_VENDOR_CONFIGURATION_ERROR } from '../../actions';
import apiCall from '../../../apiCall';

function* getVendorConfiguration({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/configurations/benefit-type/airport_transfer/vendor-onboarding`,
      method: 'GET',
      params: payload?.urlParams,
      headers: {
        ...filteredHeaders,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_VENDOR_CONFIGURATION_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_VENDOR_CONFIGURATION_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_VENDOR_CONFIGURATION_ERROR, payload: error });
  }
}

export function* watchgetVendorConfiguration() {
  yield takeEvery(GET_VENDOR_CONFIGURATION, getVendorConfiguration);
}

function* getVendorConfigurationSaga() {
  yield all([fork(watchgetVendorConfiguration)]);
}

export default getVendorConfigurationSaga;
